module.exports = __webpack_public_path__ + "media/images/samples/home/ep/ep5-65904bf99419aa6112999a2a45cae510.png";